import * as React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Hidden from '@mui/material/Hidden';
import Content from '../Common/Content';
// @ts-ignore
import Logo from '../../assets/logo.png';
import AuthContext from '../../auth-context';

export default function Navbar() {
  const matches = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const { authenticated, setAuthenticated } = React.useContext(AuthContext);

  const _logout = () => {
    localStorage.clear();
    setAuthenticated(false);
  };

  return (
    <Box sx={{ pb: { xs: 2, sm: 2, md: 6, lg: 6 } }}>
      <Box display="flex" alignItems="center">
        <Box flex={1}>
          <Box component={Link} to="/">
            <Box component="img" src={Logo} alt="logo" sx={{ width: { xs: '100px', md: '125px' } }} />
          </Box>
        </Box>
        <Box flex={1} justifyContent="flex-end" display="flex" alignItems="center">
          <Box pr={4}>
            {
              !authenticated && (
                <Typography
                  fontSize="1.1rem"
                  fontWeight="400"
                  component="a"
                  href="https://tapi.la/hablemos/"
                  target="_blank"
                  style={{ textDecoration: 'none' }}
                >
                  Contacto comercial
                </Typography>
              )
            }
            {
              authenticated && (
                <Typography fontSize="1.1rem" fontWeight="400" style={{ cursor: 'pointer' }} onClick={_logout}>
                  Cerrar sesión
                </Typography>
              )
            }
          </Box>
          <Hidden smDown>
            <Box>
              {
                authenticated && (
                  <Button
                    component="a"
                    href="https://auntap.atlassian.net/servicedesk/customer/portal/3"
                    target="_blank"
                    variant="outlined"
                    color="primary"
                    sx={{ color: 'white', borderColor: 'primary.main', borderRadius: '8px' }}
                    size={matches ? 'medium' : 'large'}
                  >
                    Ayuda
                  </Button>
                )
              }
              {
                !authenticated && (
                  <Typography
                    fontSize="1.1rem"
                    fontWeight="400"
                    component="a"
                    href="https://tapi.la"
                    style={{ textDecoration: 'none' }}
                  >
                    Home
                  </Typography>
                )
              }

            </Box>
          </Hidden>
        </Box>
      </Box>
    </Box>
  );
}
